import { render, staticRenderFns } from "./memberWatchList.vue?vue&type=template&id=e97dfa80&"
import script from "./memberWatchList.vue?vue&type=script&lang=js&"
export * from "./memberWatchList.vue?vue&type=script&lang=js&"
import style0 from "./memberWatchList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports